
<div *ngIf="porFlag">
  <div style="position: relative;">
    <button class="btn dropdown-toggle input-box" type="button" data-toggle="dropdown"> <span style="float: left;"> {{selectedText}}</span>
      <div class="dropdown-menu dropdown-menu-left" style="width: 100%;"><a class="dropdown-item first-item" style="margin: 0; width:100%;" [ngClass]="{'selected-item':value=='cusReseller'}" (click)="selectViewAs('cusReseller')" href="javascript:void(0)">Customer-Reseller</a><a class="dropdown-item first-item" style="margin: 0; width:100%;" [ngClass]="{'selected-item':value=='fedLLC'}" (click)="selectViewAs('fedLLC')" href="javascript:`void(0)">Fed LLC</a></div>
    </button>
  </div>
</div>